<template>
  <div class="page_box">
    <div class="page_table_box" style="height:calc(100% - 10px)">
      <div class="school_table_box center">
    <img src="@/assets/img/noData/no-authority.png"
      alt="暂无权限"
    />
      </div>
    </div>
    <!-- <p style="margin-top:2%;font-size:24px;color:gray;">暂无权限</p> -->
  </div>
</template>

<script>
export default {
  name: "theNoAuthority",
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>